import React, { useState, useEffect, useRef } from "react";
import classes from "./styles.module.scss";
import {text} from "./constants.js"
import { speechUpload } from "../../Api/services/speech.js";
import useToast from "../../Hooks/useToast.js";
import { toast } from "react-toastify";
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';

export const SpeechToTextUpload = () => {
    const {showToast} = useToast();
    const [file, setFile] = useState(null);
    const [fileText, setFileText] = useState('')
    const [uploading, setUploading] = useState(false)
    const fileInputRef = useRef(null);

    const ffmpeg = createFFmpeg({ log: true });


    const convertAudioFormat = async (file) => {
        await ffmpeg.load();
        const fileData = await file.arrayBuffer();
        ffmpeg.FS('writeFile', file.name, new Uint8Array(fileData));
  
        // Convert to FLAC
        const outputFileName = 'output.flac';
        await ffmpeg.run('-i', file.name, outputFileName);
  
        // Retrieve and download the converted file
        const outputData = ffmpeg.FS('readFile', outputFileName);
        const blob = new Blob([outputData.buffer], { type: 'audio/flac' });
        return blob;
    }

    const getText = (file) => {
        convertAudioFormat(file).then(convertedFild => {
            setUploading(true)
            let formData = new FormData();
            formData.append("audioFile", convertedFild)
            speechUpload(formData).then(res=>{
                setFileText(res)
                setUploading(false)
            }).catch(err=>{
                showToast(text.errorMsg, 'error')
                console.log(err)
                setUploading(false)
            })
        })
        .catch(err=>console.log(err))
    }
    
    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files[0].type.startsWith('audio/')) {
            getText(e.dataTransfer.files[0]);
        } else {
            toast(text.onlyAudioMsg, 'error')
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleFileChange = (e) => {
        getText(e.target.files[0]);
    };
    
    const handleClick = () => {
        fileInputRef.current.click();
    };
    
    return (
        <div className={classes.container}>
            <h1>{text.pageTitle}</h1>
                <div className={classes.sttContainer}>
                    <div
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onClick={handleClick}
                        className={classes.uploadContainer}>
                        {uploading ? text.uploadingMsg : text.dragMsg}
                        <input 
                            type="file"
                            accept="audio/*"
                            ref={fileInputRef} 
                            onChange={handleFileChange}/>
                    </div>
                    <div className={classes.leftBoxContainer}>
                        <div className={classes.textContainer}>
                            {fileText || text.textPlaceholder}
                        </div>
                        {/* <div className={classes.buttonsContainer}>
                            <button className={classes.button} >summarize</button>
                        </div> */}

                    </div>
                </div>
        </div>
    );
}
